import { Component } from "react";
import axios from "axios";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter";
import { funcNavigate } from "../../../../settings/utils/functions";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { header } from "../../components/header";
import { footer } from "../../components/footer";
import { toastAlerts } from "../../../../settings/utils/toastify";
import { BASE_URL, TIMEOUT } from "../../../../settings/utils/config";

class ForgotPassword extends Component {
    static contextType = simplyContext;

    state = {
        codeMelli: "",
        phoneNumber: "",
        email: "",
        newPassword: "",
        newPassword2: "",
        website: "",
        errors: {},
        generalError: "",
        loading: false,
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.context.fPreloader(false);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        funcNavigate(this.props.navigate, this.context);
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            [name]: value,
            errors: { ...prev.errors, [name]: "" },
        }));
    };

    validate = () => {
        const { codeMelli, phoneNumber, email, newPassword, newPassword2 } = this.state;
        const errors = {};

        if (!codeMelli.trim()) errors.codeMelli = "کد ملی الزامی است";
        else if (!/^\d{10}$/.test(codeMelli)) errors.codeMelli = "کد ملی باید ۱۰ رقم باشد";

        if (!phoneNumber.trim()) errors.phoneNumber = "شماره همراه الزامی است";
        else if (!/^09\d{9}$/.test(phoneNumber)) errors.phoneNumber = "شماره همراه معتبر نیست";

        if (!email.trim()) errors.email = "ایمیل الزامی است";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = "ایمیل معتبر نیست";

        if (!newPassword.trim()) errors.newPassword = "کلمه عبور جدید الزامی است";
        else if (newPassword.length < 6) errors.newPassword = "کلمه عبور حداقل ۶ کاراکتر باشد";

        if (newPassword !== newPassword2) errors.newPassword2 = "کلمه عبور و تکرار آن یکسان نیستند";

        const hasError = Object.keys(errors).length > 0;

        this.setState({
            errors,
            generalError: hasError ? "خطاهای فرم را بررسی کنید" : "",
        });

        return !hasError;
    };

    scrollToFormTop = () => {
        setTimeout(() => {
            const el = document.getElementById("forgot-form-top");
            if (el) {
                const y = el.getBoundingClientRect().top + window.pageYOffset - 200;
                window.scrollTo({ top: y, behavior: "smooth" });
            }
        }, 100);
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({ generalError: "" });

        if (!this.validate()) {
            this.scrollToFormTop();
            return;
        }
        if (this.state.loading) return;

        this.setState({ loading: true });

        axios.post(
            BASE_URL + "/api/v1/accounts/forgot-password/",
            {
                codeMelli: this.state.codeMelli,
                phoneNumber: this.state.phoneNumber,
                email: this.state.email,
                newPassword: this.state.newPassword,
                newPassword2: this.state.newPassword2,
                website: this.state.website,
            },
            {
                timeout: TIMEOUT,
                headers: { "Content-Type": "application/json" },
            }
        ).then((response) => {
            const data = response.data;
            if (data.code === "success") {
                toastAlerts({ data: { code: "success", message: data.message } });
                this.context.fNavigate("/login");
            } else {
                if (data.errors) {
                    const flat = {};
                    Object.keys(data.errors).forEach((key) => {
                        flat[key] = Array.isArray(data.errors[key])
                            ? data.errors[key][0]
                            : data.errors[key];
                    });
                    this.setState({ errors: flat, generalError: "خطاهای فرم را بررسی کنید" });
                    this.scrollToFormTop();
                }
                toastAlerts(response);
            }
            this.setState({ loading: false });
        }).catch((error) => {
            const errData = error.response?.data;
            if (errData?.errors) {
                const flat = {};
                Object.keys(errData.errors).forEach((key) => {
                    flat[key] = Array.isArray(errData.errors[key])
                        ? errData.errors[key][0]
                        : errData.errors[key];
                });
                this.setState({ errors: flat, generalError: "خطاهای فرم را بررسی کنید" });
                this.scrollToFormTop();
            }
            toastAlerts(error.response);
            this.setState({ loading: false });
        });
    };

    render() {
        const {
            codeMelli, phoneNumber, email,
            newPassword, newPassword2,
            website, errors, generalError, loading,
        } = this.state;

        return (
            <HelmetProvider>
                <Helmet>
                    <title>فراموشی رمز عبور | مرکز ملی تحقیقات راهبردی آموزش علوم پزشکی (نصر)</title>
                    <link rel="canonical" href="https://nasrme.ac.ir" />
                </Helmet>

                <div className="container-fluid cFlex1 cBg3">
                    {header(this.context)}

                    <div className="row">
                        <div className="col-12 px-0">
                            <div className="login-page">

                                <div className="login-bg">
                                    <div className="login-bg-overlay" />
                                </div>

                                <div className="login-wrapper register-wrapper" id="forgot-form-top">
                                    <div className="login-card">
                                        <div className="text-center mb-3">
                                            <img src="/images/logo.png" className="img-fluid w-50" alt="لوگو" />
                                        </div>

                                        <h1 className="login-title">فراموشی رمز عبور</h1>
                                        <p className="login-subtitle">
                                            اطلاعات خود را وارد کنید تا کلمه عبور جدید تنظیم شود
                                        </p>

                                        {generalError && (
                                            <div className="login-general-error">
                                                {generalError}
                                            </div>
                                        )}

                                        <form onSubmit={this.handleSubmit} className="login-form" noValidate>

                                            <div className="hp-field" aria-hidden="true">
                                                <label htmlFor="website">وب‌سایت</label>
                                                <input
                                                    id="website"
                                                    name="website"
                                                    type="text"
                                                    value={website}
                                                    onChange={this.handleChange}
                                                    tabIndex={-1}
                                                    autoComplete="off"
                                                />
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="codeMelli">کد ملی</label>
                                                <input
                                                    id="codeMelli"
                                                    name="codeMelli"
                                                    type="text"
                                                    value={codeMelli}
                                                    onChange={this.handleChange}
                                                    placeholder="۱۰ رقم"
                                                    disabled={loading}
                                                    className={errors.codeMelli ? "is-invalid" : ""}
                                                />
                                                {errors.codeMelli && (
                                                    <span className="login-field-error">{errors.codeMelli}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="phoneNumber">شماره همراه</label>
                                                <input
                                                    id="phoneNumber"
                                                    name="phoneNumber"
                                                    type="text"
                                                    value={phoneNumber}
                                                    onChange={this.handleChange}
                                                    placeholder="شماره همراه خود را وارد کنید"
                                                    disabled={loading}
                                                    className={errors.phoneNumber ? "is-invalid" : ""}
                                                />
                                                {errors.phoneNumber && (
                                                    <span className="login-field-error">{errors.phoneNumber}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="email">ایمیل</label>
                                                <input
                                                    id="email"
                                                    name="email"
                                                    type="email"
                                                    value={email}
                                                    onChange={this.handleChange}
                                                    placeholder="example@mail.com"
                                                    disabled={loading}
                                                    className={errors.email ? "is-invalid" : ""}
                                                />
                                                {errors.email && (
                                                    <span className="login-field-error">{errors.email}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="newPassword">کلمه عبور جدید</label>
                                                <input
                                                    id="newPassword"
                                                    name="newPassword"
                                                    type="password"
                                                    value={newPassword}
                                                    onChange={this.handleChange}
                                                    placeholder="کلمه عبور جدید"
                                                    autoComplete="new-password"
                                                    disabled={loading}
                                                    className={errors.newPassword ? "is-invalid" : ""}
                                                />
                                                {errors.newPassword && (
                                                    <span className="login-field-error">{errors.newPassword}</span>
                                                )}
                                            </div>

                                            <div className="login-field">
                                                <label htmlFor="newPassword2">تکرار کلمه عبور جدید</label>
                                                <input
                                                    id="newPassword2"
                                                    name="newPassword2"
                                                    type="password"
                                                    value={newPassword2}
                                                    onChange={this.handleChange}
                                                    placeholder="تکرار کلمه عبور جدید"
                                                    autoComplete="new-password"
                                                    disabled={loading}
                                                    className={errors.newPassword2 ? "is-invalid" : ""}
                                                />
                                                {errors.newPassword2 && (
                                                    <span className="login-field-error">{errors.newPassword2}</span>
                                                )}
                                            </div>

                                            {errors.message && (
                                                <div className="login-field-error" style={{ marginTop: 0 }}>
                                                    {errors.message}
                                                </div>
                                            )}

                                            <div className="login-actions">
                                                <button
                                                    type="submit"
                                                    className="login-btn"
                                                    disabled={loading}
                                                >
                                                    تغییر کلمه عبور
                                                </button>
                                                <a
                                                    href="/login"
                                                    className="login-forgot"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        this.context.fNavigate("/login");
                                                    }}
                                                >
                                                    بازگشت به ورود
                                                </a>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    {footer(true)}
                </div>
            </HelmetProvider>
        );
    }
}

export default withRouter(ForgotPassword);